import React, {
  useEffect,
  useMemo,
  useContext,
  createContext,
  useState,
  useRef,
} from "react";
import { Button, Spinner, Row, Col } from "react-bootstrap";
import { observer } from "mobx-react-lite";
import DataGrid, { SelectCellFormatter } from "react-data-grid";
import { Typeahead, ClearButton } from "react-bootstrap-typeahead";
import "react-bootstrap-typeahead/css/Typeahead.css";
import exceljs from "read-excel-file";
import Excel from "exceljs";

import StoryContext from "../store/context";

const nameCol = (numberOutlet, ...arr) =>
  `outlet${numberOutlet}${arr[0] || ""}`;
const indexCol = (name) => parseInt(name.replace("outlet", ""));

const Matrix = observer(() => {
  const inputFile = useRef(null);
  const store = useContext(StoryContext);
  const renderHeader = (props) => {
    const onChange = (event) => {
      setGridState((prev) =>
        prev.map((item) => ({
          ...item,
          [props.column.key]: event.target.checked,
        }))
      );
    };
    const color = store.matrixStore.curOutlets.find(
      (it) => props.column.outlet === it
    )
      ? "red"
      : "black";
    return (
      <Col style={{ whiteSpace: "pre-wrap", lineHeight: "normal", margin: 8 }}>
        <Row style={{ height: 70, color }}>{props.column.name}</Row>
        <Row>
          <input type="checkbox" onChange={onChange} />
        </Row>
      </Col>
    );
  };

  const columns = React.useMemo(
    () => [
      { name: "#", key: "num", width: 10, frozen: true },
      {
        name: "Найменування",
        key: "product",
        width: 300,
        frozen: true,
        summaryFormatter() {
          return <strong>Всього</strong>;
        },
        formatter(props) {
          const row = props.row;
          return <>{row.product.name}</>;
        },
      },
      {
        name: "Всі",
        key: "all",
        frozen: true,
        formatter({ row, onRowChange, isCellSelected }) {
          return (
            <SelectCellFormatter
              value={row.all}
              onChange={() => {
                const newRow = store.matrixStore.outlets.reduce(
                  (sum, _, indexR) => ({
                    ...sum,
                    [nameCol(indexR)]: !row.all,
                  }),
                  { ...row, all: !row.all }
                );
                onRowChange(newRow);
              }}
              isCellSelected={isCellSelected}
            />
          );
        },
        summaryFormatter({ row: { allCount, totalCount } }) {
          return <>{`${allCount}/${totalCount}`}</>;
        },
      },
      ...store.matrixStore.outlets.map((item, index) => ({
        name: item.name,
        outlet: item,
        headerRenderer: renderHeader,
        key: nameCol(index),
        width: 150,
        formatter({ row, onRowChange, isCellSelected }) {
          return (
            <div
              style={{
                backgroundColor: row[nameCol(index)].order ? "red" : "white",
                width: "100%",
                height: "100%",
              }}
            >
              <SelectCellFormatter
                style={{ color: "red" }}
                value={row[nameCol(index)].selected}
                onChange={() => {
                  onRowChange({
                    ...row,
                    [nameCol(index)]: !row[nameCol(index)].selected,
                  });
                }}
                isCellSelected={isCellSelected}
              />
            </div>
          );
        },
        summaryFormatter({ row }) {
          return <>{`${row[nameCol(index, "Count")]}/${row.totalCount}`}</>;
        },
      })),
    ],
    [store.matrixStore.currentClient, store.matrixStore.mod]
  );

  const rows = React.useMemo(() => {
    let newRows = store.matrixStore.products.map((item, index) => ({
      num: index,
      product: item,
      all: false,
      ...columns
        .slice(3)
        .reduce((sum, _, indexR) => ({ ...sum, [nameCol(indexR)]: false }), {}),
    }));

    for (const { outlet, selected, order, product } of store.matrixStore
      .matrix) {
      const index = store.matrixStore.products.findIndex(
        (element) => product.uuid === element.uuid
      );
      const id = nameCol(
        store.matrixStore.outlets.findIndex(
          (element) => outlet.uuid === element.uuid
        )
      );
      try {
        newRows[index][id] = { selected, order };
      } catch {}
    }
    return newRows;
  }, [store.matrixStore.currentClient, store.matrixStore.mod]);

  const [gridState, setGridState] = React.useState(rows);

  useEffect(() => {
    setGridState(rows);
  }, [store.matrixStore.currentClient, store.matrixStore.mod]);

  const summaryRows = useMemo(() => {
    let summaryRow = {
      id: "total_0",
      totalCount: gridState.length,
      allCount: gridState.filter((r) => r.all).length,
    };
    summaryRow = store.matrixStore.outlets.reduce(
      (sum, item, index) => ({
        ...sum,
        [nameCol(index, "Count")]: gridState.filter(
          (r) => r[nameCol(index)].selected
        ).length,
      }),
      summaryRow
    );
    return [summaryRow];
  }, [gridState]);

  const saveMatrix = () => {
    // store.matrixStore.clearMatrix();
    // const newMatrix = [];
    // for (const { num, product, all, ...cols } of gridState) {
    //   for (const col in cols) {
    //     if (
    //       store?.matrixStore?.outlets[indexCol(col)]?.uuid ??
    //       undefined !== undefined
    //     )
    //     newMatrix.push({
    //       outlet: store.matrixStore.outlets[indexCol(col)].uuid,
    //       product: product.uuid,
    //       selected: cols[col].selected,
    //       order: cols[col].order,
    //     });
    //   }
    // }
    // store.matrixStore.addMatrix(newMatrix);

    store.matrixStore.getSaveMatrix();
  };

  const loadMatrix = () => {
    inputFile.current.click();
  };

  // const readFile = async (file) => {
  //   const rows = await readXlsxFile(file);

  //   let row = rows[0];
  //   const countCol = row.length - 3;
  //   store.matrixStore.clearCurOutlets();
  //   for (let i = 0; i < 3; i++) {
  //     store.matrixStore.addCurOutlets(null);
  //   }
  //   for (let i = 3; i < row.length; i++) {
  //     const outlet = store.outlets.find(
  //       (item) => row[i] && item.code_outlet === row[i].toString()
  //     );
  //     store.matrixStore.addCurOutlets(outlet);
  //   }

  //   const arrMatrix = [];

  //   for (let i = 2; i < rows.length; i++) {
  //     row = rows[i];
  //     const product = store.products.find(
  //       (item) => row[0] && row[0].toString() === item.artikel
  //     );
  //     if (product) {
  //       console.log(row[0]);

  //       for (let j = 3; j < row.length; j++) {
  //         if (row[j] === 1) {
  //           arrMatrix.push({
  //             product,
  //             outlet: store.matrixStore.curOutlets[j],
  //             activ: true,
  //           });
  //         } else {
  //           // console.log(row[j]);
  //         }
  //       }
  //     } else {
  //       // console.log(arrMatrix.length);
  //     }
  //   }

  //   for (const curArrOutlets of store.matrixStore.curOutlets) {
  //     if (curArrOutlets) {
  //       const curOutlets = store.matrixStore.outlets.find(
  //         (item) => curArrOutlets === item
  //       );

  //       if (curOutlets) {
  //         for (const strProduct of store.matrixStore.products) {
  //           const selArrMatrix = arrMatrix.find(
  //             (itemM) =>
  //               itemM.product === strProduct && itemM.outlet === curArrOutlets
  //           );
  //           const itemMatrix = store.matrixStore.matrix.find(
  //             (it) => it.product === strProduct && it.outlet === curArrOutlets
  //           );
  //           if (selArrMatrix) {
  //             if (itemMatrix) {
  //               itemMatrix.setSelected(true);
  //             } else {
  //               store.matrixStore.addItem({
  //                 product: strProduct,
  //                 outlet: curArrOutlets,
  //                 selected: true,
  //               });
  //             }
  //           } else {
  //             if (itemMatrix) {
  //               itemMatrix.setSelected(false);
  //             }
  //           }
  //         }
  //       }
  //     }
  //   }
  //   console.log(1111);
  //   store.matrixStore.setMod();
  //   console.log(2222);
  // };

  const readFile = async (file) => {
    const workbook = new Excel.Workbook();
    await workbook.xlsx.load(file);
    const worksheet = workbook.worksheets[0];
    store.matrixStore.clearCurOutlets();
    store.matrixStore.clearMatrix();

    worksheet.eachRow((row, rowNumber) => {
      if (rowNumber === 1) {
        row.eachCell((cell, colNumber) => {
          if (colNumber > 3) {
            const outlet = store.outlets.find(
              (item) =>
                cell.value &&
                item.code_outlet === cell.value.toString() &&
                item.client.uuid === store.matrixStore.currentClient &&
                item.active
            );
            if (outlet) {
              store.matrixStore.addCurOutlets(outlet, colNumber);
            }
          }
        });
      } else if (rowNumber >= 3) {
        let product = null;
        let order = false;

        row.eachCell(function (cell, colNumber) {
          if (colNumber === 1) {
            product = store.products.find(
              (item) => cell.value && cell.value.toString() === item.artikel
            );

            order = !!cell.fill;
          } else if (colNumber >= 4) {
            const outlet = store.matrixStore.curOutlets.find(
              (item) => colNumber === item.column
            );
            if (product && outlet) {
              store.matrixStore.addItem({
                product,
                outlet: outlet.outlet,
                selected: true,
                order,
              });
            }
          }
        });
      }
    });

    store.matrixStore.setMod();
  };

  const onChangeFile = (event) => {
    event.stopPropagation();
    event.preventDefault();
    var file = event.target.files[0];
    if (file) {
      readFile(file);
    }
  };

  const onChangeSelect = async (item) => {
    if (item[0]) {
      store.matrixStore.setSelectClient(item[0].uuid);
    } else {
      store.matrixStore.setSelectClient("");
    }
    await store.matrixStore.getFetchMatrix();
    await store.matrixStore.getFetchProductsgetByClient();
  };

  const onChangeSelectKind = async (item) => {
    if (item[0]) {
      store.matrixStore.setSelectKind(item[0].uuid);
    } else {
      store.matrixStore.setSelectKind("");
    }
    await store.matrixStore.getFetchMatrix();
    await store.matrixStore.getFetchProductsgetByClient();
  };

  return (
    <>
      <div style={{ width: 800 }}>
        <Row style={{ marginBottom: 5, marginLeft: 0 }}>
          <Col>
            <Typeahead
              onChange={onChangeSelect}
              options={store.clients
                .filter((item) => item.active === true)
                .sort((s1, s2) =>
                  s1.name.toLowerCase() < s2.name.toLowerCase() ? -1 : 1
                )
                .map((item) => ({
                  ...item,
                  label: item.name,
                }))}
              placeholder="Укажіть клієнта..."
            >
              {({ onClear, selected }) => (
                <div className="rbt-aux">
                  {!!selected.length && <ClearButton onClick={onClear} />}
                </div>
              )}
            </Typeahead>
          </Col>
          <Col>
            <Typeahead
              onChange={onChangeSelectKind}
              options={store.kinds.map((item) => ({
                ...item,
                label: item.name,
              }))}
              placeholder="Вид..."
            >
              {({ onClear, selected }) => (
                <div className="rbt-aux">
                  {!!selected.length && <ClearButton onClick={onClear} />}
                </div>
              )}
            </Typeahead>
          </Col>

          <Button onClick={saveMatrix} style={{ width: 200 }}>
            Зберегти
          </Button>
          <input
            type="file"
            id="file"
            ref={inputFile}
            style={{ display: "none" }}
            onChange={onChangeFile}
          />
          <Button onClick={loadMatrix} style={{ width: 200, marginLeft: 20 }}>
            Завантажити
          </Button>
        </Row>
      </div>

      <DataGrid
        headerRowHeight={100}
        style={{ height: "90vh" }}
        columns={columns}
        rows={gridState}
        onRowsChange={setGridState}
        className="fill-grid"
        defaultColumnOptions={{
          sortable: true,
          resizable: true,
        }}
        summaryRows={summaryRows}
      />
    </>
  );
});

export default Matrix;
